import Accordion, { AccordionItem } from '@repo/ui/src/components/Accordion';
import { navigationClicked } from '@repo/ui/src/services/analytics';
import { Anchor, AnchorProps } from '@repo/ui/src/components/Anchor';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

interface Props {
  columns: Array<{
    links?: Array<AnchorProps>;
    title: string;
  }>;
  className?: string;
}

const MobileAccordion = ({ columns, className }: Props) => {
  return (
    <Accordion dark className={className} allowMultipleExpanded allowZeroExpanded>
      {columns?.map((col) => (
        <AccordionItem
          key={col.title}
          heading={col.title}
          headerClassName="border-b border-neutral-300 tra-text-web-sub-2 items-center py-2 [&_svg]:text-[#747778]"
        >
          {col?.links?.map((link) => (
            <li className="pl-4" key={link?.displayName}>
              <Anchor
                className={classNames(
                  'tra-text-web-body-s text-neutral-200 block py-2 outline-offset-2',
                  'focus:outline-brand-200 focus:outline-2 focus-visible:outline',
                  'hover:underline hover:text-brand-200',
                )}
                {...link}
                onClick={() => {
                  link.onClick?.(undefined);
                  navigationClicked({
                    nav_type: 'Footer Navigation',
                    clicked_text: link?.displayName ?? '',
                    primary_header: col.title ?? '',
                  });
                }}
              >
                {link?.displayName}
              </Anchor>
            </li>
          ))}
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default MobileAccordion;
